export default __webpack_public_path__ + "28d7e496824641f319f0dda1b4435924.svg";